import { createIcon } from "@chakra-ui/react";

const PlayArrowIcon = createIcon({
  displayName: "PlayArrowIcon",
  viewBox: "0 0 24 24",
  path: <path d="M8 19V5l11 7z" fill="currentColor" />,
});

export default PlayArrowIcon;
